import Vue from 'vue'

type PendingQuestion = { message: string; resolve: (leave: boolean) => void }

/**
 * Question asked by a route guard before leaving a page with unsaved changes, answered in
 * LeaveConfirmModal (mounted once in App.vue). A native window.confirm blocked the whole tab,
 * and froze it for good when Chrome is driven by a tool.
 */
export const leaveConfirmState = Vue.observable({
  pending: null as PendingQuestion | null,
})

/** Resolves to true when the user chooses to leave without saving. */
export async function confirmLeave(message: string): Promise<boolean> {
  // a newer navigation replaces a question left unanswered
  leaveConfirmState.pending?.resolve(false)
  return new Promise((resolve) => {
    leaveConfirmState.pending = { message, resolve }
  })
}

export function answerLeave(leave: boolean): void {
  const { pending } = leaveConfirmState
  leaveConfirmState.pending = null
  pending?.resolve(leave)
}
